import * as React from "react";
import {
  useDispatch,
  useMappedState
} from "redux-react-hook";

import { useCustomerApi } from "src/core/customers/api/customers.api";
import { setCustomer } from "src/core/customers/store/customers.actions";
import type { IStore } from "src/core/shared/store";
import { setGlobalError } from "src/core/shared/store/global/global.actions";

const useCustomer = (customerId: number) => {
  const [ isLoading, setLoading ] = React.useState(true);
  const dispatch = useDispatch();
  const [ getCustomerResponse, getCustomer ] = useCustomerApi("GET_CUSTOMER");
  const { customer } = useMappedState(({ customers }: IStore) => ({ customer: customers.customer }));

  React.useEffect(() => {
    if ((!customer || customer.id !== customerId)) {
      dispatch(setCustomer(null));
      getCustomer(customerId);
    } else {
      setLoading(false);
    }
  }, [
    customer,
    customerId,
    dispatch,
    getCustomer
  ]);

  React.useEffect(() => {
    if (getCustomerResponse.data) {
      dispatch(setCustomer(getCustomerResponse.data));
      setLoading(false);
    }

    if (getCustomerResponse.error) {
      dispatch(setGlobalError(getCustomerResponse.error));
    }
  }, [ dispatch, getCustomerResponse ]);

  return {
    isLoading,
    customer
  };
};

export default useCustomer;
